module.exports = "../../app/cells/pages/contests/index/contest_panel_cell.rb";